// Cmd/Ctrl+F opens the bar, Escape closes it and clears the text.
import React, { useEffect, useRef } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import IconButton from "@react/shared/ui/IconButton"

const SearchBar = ({ query, total, cursor, onChange, onMove, onClose }) => {
  const inputRef = useRef(null)

  useEffect(() => { inputRef.current?.focus() }, [])

  const onKeyDown = event => {
    if (event.key === "Escape") { event.preventDefault(); onClose(); return }
    if (event.key === "Enter") {
      event.preventDefault()
      onMove(event.shiftKey ? -1 : 1)
    }
  }

  const found = query.trim().length > 0

  return (
    <div className="flex items-center gap-1.5 h-8 pl-2.5 pr-1 rounded-lg border border-slate-200 bg-white focus-within:border-brand-400 focus-within:ring-[3px] focus-within:ring-brand-500/15">
      <FontAwesomeIcon icon="magnifying-glass" className="text-[11px] text-slate-400 shrink-0" />
      <input
        ref         = {inputRef}
        type        = "text"
        value       = {query}
        onChange    = {e => onChange(e.target.value)}
        onKeyDown   = {onKeyDown}
        placeholder = {I18n.t("quotes.builder.search.placeholder")}
        className   = "w-[190px] border-0 bg-transparent outline-none p-0 text-[12.5px] text-slate-900 placeholder:text-slate-400"
      />

      {found && (
        <span className="shrink-0 tabular-nums text-[11.5px] text-slate-400 whitespace-nowrap">
          {total > 0
            ? I18n.t("quotes.builder.search.position", { index: cursor + 1, total })
            : I18n.t("quotes.builder.search.none")}
        </span>
      )}

      <IconButton
        size     = "xs"
        disabled = {total < 2}
        onClick  = {() => onMove(-1)}
        title    = {I18n.t("quotes.builder.search.previous")}
        className= {total < 2 ? "opacity-30 cursor-default" : ""}
      >
        <FontAwesomeIcon icon="chevron-up" className="!w-2.5" />
      </IconButton>
      <IconButton
        size     = "xs"
        disabled = {total < 2}
        onClick  = {() => onMove(1)}
        title    = {`${I18n.t("quotes.builder.search.next")} (⏎)`}
        className= {total < 2 ? "opacity-30 cursor-default" : ""}
      >
        <FontAwesomeIcon icon="chevron-down" className="!w-2.5" />
      </IconButton>
      <IconButton size="xs" onClick={onClose} title={I18n.t("quotes.builder.search.close")}>
        <FontAwesomeIcon icon="xmark" className="!w-2.5" />
      </IconButton>
    </div>
  )
}

export default SearchBar
